/**
 * IBAN helpers: electronic normalization, checksum validation, and masking for display.
 */
import IBAN from 'iban';
/**
 * The electronic form of an IBAN (no whitespace, upper case) — the one spelling used for comparing and keying IBANs.
 */
export function normalizeIban(iban) {
    return IBAN.electronicFormat(iban);
}
/**
 * Whether the IBAN has a known country format and a valid checksum, regardless of spacing and case.
 */
export function isValidIban(iban) {
    return IBAN.isValid(normalizeIban(iban));
}
/**
 * Anonymizes an IBAN by replacing characters with X except the first two and last four characters
 * @param iban The IBAN to anonymize
 * @returns Anonymized IBAN with formatting
 */
export function anonymizeIban(iban) {
    if (!iban) {
        return null;
    }
    // Remove all spaces and format
    const cleanIban = iban.replace(/\s/g, '');
    // Format with spaces every 4 characters
    let formatted = '';
    for (let i = 0; i < cleanIban.length; i++) {
        if (i > 0 && i % 4 === 0) {
            formatted += ' ';
        }
        formatted += cleanIban[i];
    }
    // Split into characters to work with individual characters including spaces
    const chars = formatted.split('');
    // Find positions of non-space characters
    const nonSpaceIndices = [];
    chars.forEach((char, index) => {
        if (char !== ' ') {
            nonSpaceIndices.push(index);
        }
    });
    // Replace non-space characters with X except first 2 and last 4
    const totalNonSpaceChars = nonSpaceIndices.length;
    nonSpaceIndices.forEach((charIndex, nonSpaceIndex) => {
        // Keep first 2 and last 4 non-space characters
        if (nonSpaceIndex >= 2 && nonSpaceIndex < totalNonSpaceChars - 4) {
            chars[charIndex] = 'X';
        }
    });
    return chars.join('');
}
